import { Center } from "@chakra-ui/react"
import { FC } from "react"
import { ContainerWrapper } from "../../wrappers/ContainerWrapper"
import { LoginFormContainer } from "./LoginForm"

export const LoginPage: FC = () => {
	return (
		<ContainerWrapper>
			<Center height={"100vh"}>
				<LoginFormContainer />
			</Center>
		</ContainerWrapper>
	)
}
